/*
 * kuvr-signup-check.js — honest handling when a registered email uses the 10% signup.
 * Added 2026-08-24 (Duncan: "they really need to be notified rather than just letting
 * it fail silently"). Pairs with Nexus /api/shopify/signup-check.
 *
 * THE DEAD END THIS REMOVES: the newsletter popup and footer form are Shopify
 * {% form 'customer' %} posts. An already-registered email "succeeds" (Shopify never
 * discloses existing accounts) but the welcome flow only fires on a NEW Klaviyo list
 * add — an existing subscriber/customer sees "thanks!" and no code ever arrives.
 * Live case: a pre-launch subscriber with one order expected the launch code.
 *
 * WHAT IT DOES: on submit of any .newsletter-form, ask Nexus about the typed email
 * FIRST — the submit moment is the only point where an anonymous visitor's identity
 * is certain (WELCOME-FLOW-SPEC §3's cookie-based popup suppression cannot know a
 * returning visitor on a fresh device; this can).
 *   'customer'   → previous order exists: say the first-order code doesn't apply.
 *   'subscriber' → already on the list, no orders: say so, point at /pages/contact.
 *   'ok' / any error / timeout → submit normally. FAIL OPEN — this must never cost
 *   a real signup. (Guarded to never double-run per form; native submit is re-used
 *   so Shopify's own flow, tags and success state stay exactly as they were.)
 *
 * Copy rules per KUVR-COPY-GUARDRAILS: short sentences, calm, no fear language.
 * Registered in kuvr_theme_deploy.py MARKERS.
 */
(function () {
  var ENDPOINT = 'https://nexus.kuvr.co/api/shopify/signup-check';
  var TIMEOUT_MS = 2500;

  var MESSAGES = {
    customer:
      "This email is already registered from a previous order. The 10% code is for first orders only.",
    subscriber:
      "You're already on our list with this email. If your 10% code never arrived, <a href=\"/pages/contact\">talk to us</a> and we'll put it right."
  };

  function showNote(form, status) {
    var note = form.querySelector('.kuvr-signup-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'kuvr-signup-note';
      note.setAttribute('role', 'alert');
      note.style.cssText =
        'margin-top:10px;padding:10px 14px;border:1px solid #c9a227;background:#fdf6e3;' +
        'color:#5b4a00;font-family:Lato,sans-serif;font-size:14px;line-height:1.5;border-radius:4px;text-align:left;';
      form.appendChild(note);
    }
    note.innerHTML = MESSAGES[status];
  }

  function setBusy(form, busy) {
    form.querySelectorAll('[type="submit"]').forEach(function (b) { b.disabled = busy; });
  }

  function check(email) {
    return new Promise(function (resolve) {
      var done = false;
      var finish = function (status) { if (!done) { done = true; resolve(status); } };
      setTimeout(function () { finish('ok'); }, TIMEOUT_MS); // fail open on slowness
      try {
        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email })
        })
          .then(function (r) { return r.ok ? r.json() : { status: 'ok' }; })
          .then(function (j) { finish(j && j.status ? j.status : 'ok'); })
          .catch(function () { finish('ok'); });
      } catch (e) { finish('ok'); }
    });
  }

  /* 🛑 WHY CLICK-CAPTURE AND NOT A SUBMIT LISTENER (measured live 2026-08-24):
   * a submit listener with preventDefault() looked right and DID prevent the event
   * (defaultPrevented=true at bubble phase) — and the form POSTed anyway, landing on
   * /challenge?form_type=customer. Shopify's own bot-protection script also observes
   * customer-form submit events and performs the submission itself, ignoring
   * defaultPrevented; no form.submit() of ours ever ran (proved with a prototype
   * probe). The only reliable gate is BEFORE any submit event exists: capture the
   * button click (and the Enter key), run the check, and only then re-trigger the
   * native click so Shopify's whole pipeline — captcha included — runs untouched. */
  function handleTrigger(form, ev, retrigger) {
    if (form.__kuvrChecked) { form.__kuvrChecked = false; return; } // our own re-trigger: let it through
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var email = emailInput && emailInput.value ? emailInput.value.trim() : '';
    if (!email) return; // let native validation complain
    ev.preventDefault();
    ev.stopPropagation();
    setBusy(form, true);
    check(email).then(function (status) {
      setBusy(form, false);
      if (status === 'customer' || status === 'subscriber') { showNote(form, status); return; }
      var note = form.querySelector('.kuvr-signup-note');
      if (note) note.remove();
      form.__kuvrChecked = true;
      retrigger();
    });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('form.newsletter-form [type="submit"]') : null;
    if (!btn) return;
    var form = btn.closest('form.newsletter-form');
    if (!form) return;
    handleTrigger(form, ev, function () { btn.click(); });
  }, true);

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var input = ev.target && ev.target.closest ? ev.target.closest('form.newsletter-form input[name="contact[email]"]') : null;
    if (!input) return;
    var form = input.closest('form.newsletter-form');
    handleTrigger(form, ev, function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.click();
    });
  }, true);
})();
